// @flow
import React, { Component } from 'react';

import Nav from './Nav';
import { globalSettingsPages } from './pageData';
import '../admin-styles.css';

type Props = {
  isFullAdmin: boolean,
  hasIdentityService: boolean,
};

class GlobalSettingsPage extends Component<Props> {
  render() {
    const { isFullAdmin, hasIdentityService } = this.props;
    return (
      <div className="page">
        <Nav
          className="nav-secondary"
          hasIdentityService={hasIdentityService}
          isFullAdmin={isFullAdmin}
          navItemClass="nav-item nav-item-secondary"
          navListClass="nav-list nav-list-secondary"
          pages={globalSettingsPages}
        />
      </div>
    );
  }
}

export default GlobalSettingsPage;



// WEBPACK FOOTER //
// ./src/view/App/GlobalSettingsPage.js